import React, {useCallback } from "react";
import { useSelector } from "react-redux";
import { Form  } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import FiscalReferenceDetails from './fiscalReferencesDetails'
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import { useMultipleInvoiceItem } from "../../hooks/useMultipleInvoiceItem";


 const FiscalReference=({invoiceId})=> {

  const {
    isLoading,
    AddItem,
    deleteItem,
    updateItem,
    saveItem
  } = useMultipleInvoiceItem({tableName:"additionalFiscalReferences",invoiceId})
     
     const isFormEnabled=false

    const additionalFiscalReferences =
    useSelector(
      (state) =>
        state.InvoicesReducer.invoice.invoiceList[invoiceId].additionalFiscalReferences
    ) || []
    
    const renderItem=useCallback((item)=>{
     return  <FiscalReferenceDetails
     key={item.id}
     invoiceId={invoiceId}
     item={item}
    //  isFormEnabled={isFormEnabled}
     updateData={updateItem}
     deleteData={deleteItem}
     saveData={saveItem}
     />
    },[deleteItem,updateItem,saveItem])
    
    return (
   
        <Form.Group className="float-container">
          <FormTitle
           title="Additional Fiscal Reference"
           boxNumber="3/40"
           >
           </FormTitle>
          <List renderItem={renderItem}
            dataSource={additionalFiscalReferences} 
          />
  
        
  { isLoading && <CustomLoader /> }
      {
        additionalFiscalReferences?.length<9 && 
        <AddBtn
         disabled={isLoading} 
         id={`addFiscalRef-${invoiceId}`}
         onClick={AddItem} 
        text="Add">

      </AddBtn>
 }
     
        </Form.Group>
     
    );
  }
  
  export default React.memo(FiscalReference)
